import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import XLSX from 'xlsx';
import standardTable from '@/components/standardTable/index';
export default {
  components: {
    standardTable
  },
  data() {
    return {
      loading: false,
      tableData: [],
      tableHead: []
    };
  },
  methods: {
    handleChange(e) {
      const file = e.target.files[0];
      if (!file) return;
      //判断格式
      if (!this.isExcel(file)) {
        this.$message.warning(this.$t('只能选择xlxs,xls文件'));
        return;
      }
      //判断大小
      if (file.size / 1024 / 1024 > 1) {
        this.$message.warning(this.$t('上传文件大小不能超过1M'));
        return;
      }
      this.loading = true;
      const reader = new FileReader();
      reader.readAsArrayBuffer(file);
      reader.onload = e => {
        const data = e.target.result;
        const workbook = XLSX.read(data, {
          type: 'array'
        });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        setTimeout(() => {
          this.loading = false;
          const head = this.getHeaderRow(worksheet);
          this.tableHead = head.map(item => {
            return {
              title: item,
              dataIndex: item
            };
          });
          const tableData = XLSX.utils.sheet_to_json(worksheet);
          tableData.forEach(item => {
            item.id = parseInt(Math.random(0, 1) * 10000);
          });
          this.tableData = tableData;
        }, 500);
      };
    },
    generateData({
      header,
      results
    }) {
      this.excelData.header = header;
      this.excelData.results = results;
      this.onSuccess && this.onSuccess(this.excelData);
    },
    //获取表头
    getHeaderRow(sheet) {
      const headers = [];
      const range = XLSX.utils.decode_range(sheet['!ref']);
      let C;
      const R = range.s.r;
      for (C = range.s.c; C <= range.e.c; ++C) {
        const cell = sheet[XLSX.utils.encode_cell({
          c: C,
          r: R
        })];
        let hdr = 'UNKNOWN ' + C;
        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell);
        headers.push(hdr);
      }
      return headers;
    },
    handleUpload() {
      this.$refs['excel-upload'].click();
    },
    isExcel(file) {
      return /\.(xlsx|xls|csv)$/.test(file.name);
    }
  }
};